export const TRANSLATE_X = 5;
